var _path;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
var SvgSettingsSafari = function SvgSettingsSafari(_ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 40 40",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#2E7CF6",
    d: "M20 23.7c.3 0 .6-.3.6-.7V10l1 1 1.7 1.9.4.2c.3 0 .6-.3.6-.6 0-.2 0-.3-.2-.5l-3.6-3.7L20 8c-.2 0-.3 0-.4.2L15.9 12l-.2.5c0 .3.3.6.6.6l.4-.2 1.8-2 1-1-.1 1.6V23c0 .4.3.7.6.7M14 32h12c2 0 3-1 3-3.2v-11c0-2-1-3.1-3-3.1h-3V16h3c1 0 1.7.6 1.7 1.9v10.9c0 1.2-.6 1.9-1.8 1.9H14.1c-1.2 0-1.8-.7-1.8-2V18c0-1.3.6-1.9 1.8-1.9h3v-1.3h-3c-2 0-3.1 1-3.1 3.1v11c0 2.1 1 3.2 3 3.2Z"
  })));
};
export default SvgSettingsSafari;